import { Breakpoints, Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { NormalizedVoucher, GetPersonUser } from '@esportal/portal-service';
import { VouchersPopupLayerContent } from './vouchers-popup-layer-content';
import { VouchersvwBank } from './benefits-vwbank';
import { PromotionPopupLayerContent } from './promotion-popup-layer-content';
import { PortalContext } from '../../../../context/portal-context';
import { BenefitsCombined } from '../../benefits';

const VoucherBenefitsContent: React.FC<{
	vouchersPopupData: NormalizedVoucher;
	userData: GetPersonUser | null;
}> = ({ vouchersPopupData, userData }) => {
	const [isVwBankLayerVisible, setIsVwBankLayerVisible] = React.useState(false);
	const vwBankUrl = vouchersPopupData.layer?.cta?.src;

	if (isVwBankLayerVisible && vwBankUrl) {
		return <VouchersvwBank vwBankUrl={vwBankUrl} userData={userData} vouchersPopupData={vouchersPopupData} />;
	}

	return (
		<VouchersPopupLayerContent
			vouchersPopupData={vouchersPopupData}
			vwBankLayer={() => setIsVwBankLayerVisible(true)}
		/>
	);
};

// contenido del layer de vouchers/promociones; se renderiza vía layerManager.openFocusLayer desde useBenefitsPopupLayer
export const BenefitsPopupLayerContent: React.FC<{
	benefit: BenefitsCombined | undefined;
	userData: GetPersonUser | null;
	portalContext: React.ContextType<typeof PortalContext>;
	handleClose: () => void;
}> = ({ benefit, userData, portalContext, handleClose }) => {
	return (
		<PortalContext.Provider value={portalContext}>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b1600]: ContainerPadding.dynamic0100,
					},
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={handleClose}
					aria-label="Close pop-up"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			{(() => {
				if (!benefit) return <></>;

				if (benefit.type === 'voucher') {
					return <VoucherBenefitsContent vouchersPopupData={benefit.data} userData={userData} />;
				}

				return <PromotionPopupLayerContent promotionBenefit={benefit.data} />;
			})()}
		</PortalContext.Provider>
	);
};
